import React from "react";
import {Col, Row} from "antd";
import {AnnouncementRow} from "./announcementRow/AnnouncementRow";
import {OrderStats} from "./orderStats/OrderStats";
import {DeliveryListBlock} from "./deliveryListBlock/DeliveryListBlock";
import {observer} from "mobx-react-lite";
import {CustomerFluidSubPageLayout} from "components/layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
const CustomerHomePage = observer(() => {
    return (
        // <CustomerHomeLayout>
        <CustomerFluidSubPageLayout>
            <CustomerMenuHeader />
            <Row style={{width: "100%", padding: "0"}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <AnnouncementRow />
                </Col>
            </Row>

            <Row style={{width: "100%", marginTop: "12px", padding: "0"}}>
                <Col xs={24}>
                    <OrderStats />
                </Col>
            </Row>

            <Row style={{width: "100%", marginTop: "40px", marginBottom: "80px"}}>
                <Col xs={24}>
                    <DeliveryListBlock />
                </Col>
            </Row>
        </CustomerFluidSubPageLayout>
        // </CustomerHomeLayout>
    );
});

export default CustomerHomePage;
